module.exports = __webpack_public_path__ + "static/profilepic-a0744cf020b0cf66cbce6df15dded91c.jpg";